import React from "react";

const OptimizedImage = ({ webpSrc, fallbackSrc, alt, ...props }) => {
  // Ensure we have at least one valid source
  if (!webpSrc && !fallbackSrc) {
    return null;
  }

  return (
    <picture>
      {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
      <img src={fallbackSrc || webpSrc} alt={alt} {...props} />
    </picture>
  );
};

export default OptimizedImage;
